import { createMemoryHistory, createRouter } from 'vue-router';

import HomeView from '@/pages/HomeView.vue';
import AboutView from '@/pages/AboutView.vue';
import IndustrySolutionsView from '@/pages/IndustrySolutionsView.vue';
import CoreServiceView from '@/pages/CoreServiceView.vue';
import CaseStudiesView from '@/pages/CaseStudiesView.vue';
import ResourceCenterView from '@/pages/ResourceCenterView.vue';
import CustomerSupportView from '@/pages/CustomerSupportView.vue';
import ContactView from '@/pages/ContactView.vue';

const routes = [
  { path: '/', component: HomeView },
  { path: '/about', component: AboutView },
  { path: '/product', component: IndustrySolutionsView },
  { path: '/service', component: CoreServiceView },
  { path: '/case-studies', component: CaseStudiesView },
  { path: '/resource-center', component: ResourceCenterView },
  { path: '/customer-support', component: CustomerSupportView },
  { path: '/contact', component: ContactView },
];

const getRouteScrollTarget = (to) => {
  if (to.hash) {
    return to.hash;
  }

  const section = Array.isArray(to.query?.section) ? to.query.section[0] : to.query?.section;
  return typeof section === 'string' && /^[a-zA-Z][\w-]*$/.test(section) ? `#${section}` : '';
};

const scrollToRouteTarget = (selector) => {
  const target = document.querySelector(selector);

  if (!target) {
    return;
  }

  const targetTop = target.getBoundingClientRect().top + window.pageYOffset - 96;
  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: 'smooth',
  });
};

const router = createRouter({
  history: createMemoryHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    const target = getRouteScrollTarget(to);

    if (target) {
      return {
        el: target,
        top: 96,
        behavior: 'smooth',
      };
    }

    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (!getRouteScrollTarget(to)) {
    window.scrollTo(0, 0);
  }
  try { window.dispatchEvent(new CustomEvent('ykdb:route-changed')); } catch (e) {}
  next();
});

router.afterEach((to) => {
  const target = getRouteScrollTarget(to);

  if (target) {
    window.setTimeout(() => scrollToRouteTarget(target), 120);
  }
});

export default router;
